import { render, staticRenderFns } from "./testItem-upload.vue?vue&type=template&id=3e648826&scoped=true"
import script from "./testItem-upload.vue?vue&type=script&lang=js"
export * from "./testItem-upload.vue?vue&type=script&lang=js"
import style0 from "./testItem-upload.vue?vue&type=style&index=0&id=3e648826&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e648826",
  null
  
)

export default component.exports